import { OrgSettingListResponse, Setting } from '~/common_models/organization_settings_list_model';

export enum OrganizationSettingType {
  LANGUAGE_SETTINGS = 'language',
  DEFAULT_REGION = '1',
  FT_OPERATING_REGION = '2',
  SV_OPERATING_REGION = '4',
  REGION_LEVEL_SETTINGS = 'REGION_LEVEL_SETTINGS',
  // ... and so on for other settings if they exist
}

export enum OrganizationSettingKey {
  DEFAULT_REGION = 'org_defaultregion_assignment_configuration_organisation',
  FT_OPERATING_REGION = 'org_operatingregion_assignment_configuration_fieldtechnician',
  SV_OPERATING_REGION = 'org_operatingregion_assignment_configuration_supervisor',
  LANGUAGE_SETTINGS = 'org_application_language_configuration_default',
  CURRENCY_SETTINGS = 'org_application_currency_configuration_default',
  NUMBER_FORMAT_SETTINGS = 'org_application_number_format_configuration_default',
  SEASON_AREA_GOAL_KEY = 'org_application_areametricunit_configuration_default',
  SEASON_YIELD_GOAL_KEY = 'org_application_weightmetricunit_configuration_default',
  COLLECTION_CENTRE_GEO_STRUCTURE_LEVEL = 'org_collection_centre_geo_structure_level',
  FULFILMENT_CENTRE_GEO_STRUCTURE_LEVEL = 'org_fulfilment_centre_geo_structure_level',
  COLLECTION_ZONE_GEO_STRUCTURE_LEVEL = 'org_collection_zone_geo_structure_level',
  DISTRIBUTION_CENTRE_GEO_STRUCTURE_LEVEL = 'org_distribution_centre_geo_structure_level',
  BILLING_ENTITY_GEO_STRUCTURE_LEVEL = 'org_billing_entity_geo_structure_level',
}

export const getOrgSettingForSettingType = (
  settingType: OrganizationSettingKey,
  array: OrgSettingListResponse
): Setting | undefined => {
  return array?.settings?.find((item) => item.settingKey == settingType);
};

export const region = {
  '1': 'region_id',
  '2': 'region_part_id',
  '3': 'settlement_id',
  '4': 'settlement_part_id',
};

export enum SettingInputType {
  TEXT = 1,
  NUMBER = 2,
  DATE = 3,
  BOOLEAN = 4,
  SELECT = 5,
  MULTI_SELECT = 6,
  RADIO = 7,
  CHECKBOX = 8,
  DROPDOWN = 9,
}
